/**
 * Menu categories hook
 * Thin wrapper around data layer using React Query
 */

import { useQuery } from "@tanstack/react-query";
import { menuKeys, queryOptions } from "@/data/query-keys";
import { getMenuCategories } from "@/data/supabase/menu";
import { getCurrentUserCompanyId } from "@/lib/userUtils";

// Re-export type for backward compatibility
export type { MenuCategory } from "@/data/supabase/menu";

export const useMenuCategories = () => {
  return useQuery({
    queryKey: menuKeys.categories(),
    queryFn: async () => {
      const companyId = await getCurrentUserCompanyId();
      if (!companyId) return [];
      return getMenuCategories(companyId);
    },
    staleTime: queryOptions.menu.staleTime,
    gcTime: queryOptions.menu.gcTime,
  });
};
